import { ApiResourceMethod } from '@/api/api-requests-factory';
import { ProcessingModeratedTransaction } from '@/models/payment/processing-moderated-transaction.model';
import { ModerationStatus } from '@/models/payment/moderation-status.model';

export class UpdateProcessingModeratedTransactionRequest extends ApiResourceMethod<ProcessingModeratedTransaction> {
  public perform(
    whitelabelSlug: string, playerId: string, status: ModerationStatus,
  ): Promise<ProcessingModeratedTransaction> {
    return this.performer.requestWithMapper({
      url: `${whitelabelSlug}/player/${playerId}/bpWlTransactionModerationInfo`,
      data: { status },
    });
  }
}
